import { Button, Row } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useCallback } from "react";

type HeaderProps = {
  title: string;
  accountId: string;
  onBackButtonClicked: (() => void) | undefined;
};

export const Header = ({
  title,
  accountId,
  onBackButtonClicked,
}: HeaderProps) => {
  const handleBackButtonClick = useCallback(() => {
    if (onBackButtonClicked) {
      onBackButtonClicked();
    }
  }, [onBackButtonClicked]);

  return (
    <Row className="w-100 px-8 profile-header align-center">
      <Button
        shape="circle"
        icon={<ArrowLeftOutlined />}
        size="large"
        className="back-btn mr-6"
        onClick={handleBackButtonClick}
      />
      <Row className="d-block">
        <h3 className="h h3">{title}</h3>
        <span className="text-sm title">#{accountId}</span>
      </Row>
    </Row>
  );
};
